export default function (status) {
  this.sendEvent('subscription.transaction.done.ios', { status })
}
